//=========== Our promise(Anirban) ===========
 jQuery(".promise_list  a").on('click', function(e) {
  alert("ssd")
   // prevent default anchor click behavior
   e.preventDefault();
   

   // store hash
   var hash = this.hash;

   // animate
   jQuery('html, body').animate({
       scrollTop: jQuery(hash).offset().top
     }, 1000, function(){

       // when done, add hash to url
       // (default click behaviour)
       window.location.hash = hash;
     });

});
jQuery(document).ready(function($) {

}(jQuery));


    

